<script>
export default {
  name: 'QTRMenu',
  methods: {
    goto(formType) {
      this.$router.push({
        name: 'FormSearch',
        params: { formType }
      })
    },
    regenerate() {
      this.$bvModal
        .msgBoxConfirm(
          'Are you sure you want to refresh the underlying views that the quarterly completeness metrics utilize? Note: this process can take several minutes.',
          {
            title: 'Please Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(value => {
          if (value) {
            this.graphql(/* GraphQL */ `
              mutation {
                refreshQtrMetricsViews(input: {}) {
                  clientMutationId
                }
              }
            `)
          }
        })
    },
    runReports() {
      this.$bvModal
        .msgBoxConfirm(
          'Are you sure you want to run the quarterly completeness reports for last quarter?  Note: this will overwrite what is currently on the website.',
          {
            title: 'Please Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(value => {
          if (value) {
            this.graphql(/* GraphQL */ `
              mutation {
                runQtrDatastreamCompleteness(input: { automated: false }) {
                  clientMutationId
                }
              }
            `)
          }
        })
    }
  }
}
</script>

<template>
  <div class="p-4">
    <b-card-group deck class="w-100">
      <b-card
        title="Exceptions"
        class="m-2"
        @click="goto('qtrMetricsExceptions')"
      >
        <b-card-text>
          Manage quarterly completeness exceptions
        </b-card-text>
      </b-card>
      <b-card title="Filters" class="m-2" @click="goto('qtrMetricsFilters')">
        <b-card-text>
          Manage quarterly completeness filters
        </b-card-text>
      </b-card>
      <b-card title="Modes" class="m-2" @click="goto('finalize')">
        <b-card-text>
          Manage quarterly completeness manually set modes
        </b-card-text>
      </b-card>
    </b-card-group>
    <b-card-group deck class="w-100">
      <b-card title="Regenerate" class="m-2" @click="regenerate">
        <b-card-text>
          Regenerate the base views for the quarterly completeness metrics
          reports
        </b-card-text>
      </b-card>
      <b-card title="Run Last Quarter" class="m-2" @click="runReports">
        <b-card-text>
          Run the quarterly completeness reports for the last quarter
        </b-card-text>
      </b-card>
    </b-card-group>
  </div>
</template>
